export default {
  pleaseSelectClass: 'please select the class',
  pleaseSelectAttr: 'please select the attribute',
  createCode: 'create code',
  editCode: 'edit the code',
  classAttrName: 'class attribute name',
  classAttrCode: 'class attribute code',
  classAttrValue: 'class attribute value',
  selectTime: 'select the time',
  selectDate: 'select the date',
  viewCode: 'view the code',
  upload: 'upload',
  viewHistoryData: 'view the history data',
  submit: 'submit',
  title: 'title',
  flowType: 'flow type',
  flowStatus: 'flow status',
  pleaseSelectFlowStatus: 'please select the flow status',
  approver: 'approver',
  pleaseSelectApprover: 'please select the approver',
  deadLineTime: 'deadline time',
  pleaseSelectTheDeadLineTime: 'please select the dead line time',
  createdTime: 'created time',
  uploader: 'uploader',
  cancelTheCode: 'are you sure to cancel the code?',
  deleteTheCode: 'are you sure to delete the code?',
  uploadFile: 'uploadFiile',
  pleaseSelectOrEnder: 'please select or enter the no.',
  classAttributeValue: 'class attribute value',
  unreleased: 'unreleased',
  canceled: 'canceled',
  success: 'success',
  auditing: 'auditing',
  pleaseCreateTheNotHandoverObject: 'please add the objects to be handed over',
  pendingSubmissionPhase: 'pending submission phase',
  at: 'at',
  launchProcess: 'launch process',
  codeApproveProcess: 'code approve process',
  handoverObject: 'handover object',
  flowApprove: 'flow approve',
  codeEdit: 'code edit',
  codeHistory: 'code history',
  codeCancel: 'code cancel',
  codeDelete: 'code delete',
  codeView: 'code view',
  handover: 'handover',
  joinHandover: 'join the handover',
  handedOver: 'handedOver',
  examine: 'examine',
  increase: 'increase',
  failed: 'failed',
  passed: 'passed',
  promoter: 'promoter',
  sendTime: 'sendTime',
}
